<template>
  <div class="text-center">
    <RevIllustration
      alt=""
      aria-hidden="true"
      class="mx-auto h-96 w-1/2 md:w-320"
      :height="500"
      src="/img/listings/no-results.svg"
      :width="500"
    />
    <h2 class="heading-2 mt-12">
      {{ i18n(translations.title) }}
    </h2>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './NoSearch.translations'

const i18n = useI18n()
</script>
